import React from "react"
// Styles
import { OverrideGlobalStyle, Nav, Wrapper, BoxLink } from "./styles"
import SheroesFav from "../../images/fav.png"

export function MobileMenu({ menuOpen, items, setMenuOpen }) {
  return (
    <>
      <OverrideGlobalStyle menuOpen={menuOpen} />
      <Wrapper menuOpen={menuOpen}>
        <Nav
          href="https://shrs.me/Pq2e8qIkuW"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://img.sheroes.in/img/uploads/sheroespage/logoes/1532598677ic_sheroes_launcher.png"
            alt="Sheroes"
          />
          <p>Join the tribe:</p>

          <p>Download the #SHEROES App</p>
        </Nav>
      </Wrapper>
    </>
  )
}
